/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCoinEuro = createReactComponent("outline", "coin-euro", "IconCoinEuro", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14.401 8c-.669 -.628 -1.5 -1 -2.401 -1c-2.21 0 -4 2.239 -4 5s1.79 5 4 5c.9 0 1.731 -.372 2.4 -1", "key": "svg-1" }], ["path", { "d": "M7 10.5h4", "key": "svg-2" }], ["path", { "d": "M7 13.5h4", "key": "svg-3" }]]);

export { IconCoinEuro as default };
//# sourceMappingURL=IconCoinEuro.mjs.map
